<template>
    <vs-popup classContent="popup-example" :title="translate('AddKey')" :active.sync="popUps.popupAddSubBeneficiary">
      <div class="vx-row mb-6" v-if="deals.length>0">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select deal"
              autocomplete
              class="selectExample w-full"
              label="Deal"
              v-model="formParams.deal"
              >
              <vs-select-item :key="index" :value="item.deal" :text="item.deal" v-for="(item,index) in deals" />
          </vs-select>
          </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('sub_name')" v-model="formParams.sub_name" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('position_title')" v-model="formParams.position_title" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('description')" v-model="formParams.description" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('first_name')" v-model="formParams.first_name" />
        </div>
      </div>
            
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('last_name')" v-model="formParams.last_name" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('address')" v-model="formParams.address" />
        </div>
      </div>
      <div class="vx-row mb-6" v-if="countries.length>0">
        <div class="vx-col w-full">
          <vs-select
              placeholder="Select country"
              autocomplete
              class="selectExample w-full"
              label="Country"
              v-model="formParams.country"
              >
              <vs-select-item :key="index" :value="item.country" :text="item.country" v-for="(item,index) in countries" />
          </vs-select>
          </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('phone')" v-model="formParams.phone" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('email')" v-model="formParams.email" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('skype')" v-model="formParams.skype" />
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-input class="inputx w-full" :label="translate('telegram')" v-model="formParams.telegram" />
        </div>
      </div>      
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <vs-button @click="addSubBeneficiary()" color="primary" type="filled">{{translate('Save')}}</vs-button>
        </div>
      </div>
    </vs-popup>
</template>
<script>
import axios from "@/axios.js"
export default {
    props:['closePopups','formParams','popUps','openAlert'],
    data() {
        return {
          deals: [],
          countries: []
        }
    },
    watch: {
    'popUps.popupAddSubBeneficiary'(val) {
      
      if(val===true && this.deals.length===0)
        this.getDeals();
      }
      
    },
    methods:{
      getDeals: function(){
        let that = this;
        this.$vs.loading();
        axios.get("https://crm.evblock.com/api/lists?deals")
        .then((response) => {
          that.$vs.loading.close();
          for(let i in response.data){
            const obj = JSON.parse(response.data[i].object);
            that.deals.push(obj);
          }
        })
        .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
        axios.get("https://crm.evblock.com/api/lists?countries")
        .then((response) => {
          that.$vs.loading.close();
          for(let i in response.data){
            const obj = JSON.parse(response.data[i].object);
            that.countries.push(obj);
          }
        })
        .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
      },
      addSubBeneficiary: function(){
        let that = this;
        this.$vs.loading();
        axios.post("https://crm.evblock.com/api/sub-beneficiary",this.formParams)
        .then((response) => {
          that.$vs.loading.close();
          if(response.data[0].out1=='done!'){
            that.closePopups();
            that.openAlert('success','Success');
            that.componentKey++;
          } else{
             that.openAlert('danger','Failed',response.data[0].out1);
          }
        })
      .catch(() => { that.$vs.loading.close(); that.openAlert('danger','Failed'); })
      },
      translate: function(key){
        return this.$t(key);
      },      
    }
}
</script>